import type { SVGProps } from "react";
export default function SvgProposalAppNoShadow(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 112 112"
			{...props}
		>
			<path
				fill="#FAFF00"
				stroke="#FAFF00"
				d="M5.37 66.759H21.04c2.14 0 3.868 1.722 3.868 3.842v21.36c0 2.12-1.728 3.841-3.868 3.842H5.369c-2.14 0-3.869-1.722-3.869-3.842V70.6c0-2.12 1.729-3.842 3.87-3.842Z"
			/>
			<path
				fill="url(#paint0_linear_1110_644)"
				fillOpacity={0.6}
				stroke="url(#paint1_linear_1110_644)"
				d="M33.603 43.603h15.672c2.14 0 3.868 1.722 3.868 3.841v44.517c0 2.12-1.728 3.841-3.868 3.842H33.603c-2.14 0-3.869-1.722-3.87-3.842V47.444c0-2.12 1.73-3.842 3.87-3.842Zm28.235-27.406H77.51c2.14 0 3.868 1.723 3.868 3.842v71.922c0 2.12-1.727 3.841-3.868 3.842H61.838c-2.14 0-3.869-1.722-3.869-3.842V20.039c0-2.12 1.729-3.842 3.87-3.842Z"
			/>
			<foreignObject width={137.317} height={96.2861} x={-8.31689} y={18.0146}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_0_1110_644_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter0_i_1110_644)">
				<path
					fill="white"
					fillOpacity={0.01}
					d="m110.39 55.646-19.15-19.03c-.806-.801-2.11-.801-2.915 0l-19.15 19.03c-1.298 1.289-.381 3.496 1.457 3.496h6.764c0 18.58 1.961 27.858-67.713 37.159h66.633c5.558 0 10.847-3.053 14.98-6.738 11.309-9.732 10.893-24.296 10.875-30.421h6.765c1.834 0 2.754-2.207 1.457-3.496z"
				/>
				<path
					stroke="url(#paint2_linear_1110_644)"
					strokeOpacity={0.5}
					d="M88.677 36.97a1.57 1.57 0 0 1 2.21 0L110.038 56l.036.036c.925.975.239 2.606-1.139 2.606h-7.266l.001.502c.019 6.157.411 20.478-10.7 30.04l-.006.006c-4.093 3.65-9.267 6.61-14.648 6.61H16.924c13.876-1.997 24.589-4.01 32.858-6.132 9.635-2.474 15.99-5.105 20.174-8.059 4.206-2.97 6.209-6.264 7.143-10.01.924-3.703.797-7.845.797-12.457v-.5h-7.265c-1.397 0-2.08-1.672-1.104-2.642z"
				/>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_1110_644"
					x1={55.6906}
					x2={55.6906}
					y1={15.6973}
					y2={96.3024}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={1} stopColor="#BBD3DD" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1110_644"
					x1={55.4252}
					x2={11.8637}
					y1={41.2998}
					y2={88.3636}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset={0.519231} stopColor="#A6BEC4" />
					<stop offset={1} stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_1110_644"
					x1={60.3415}
					x2={60.3415}
					y1={36.0146}
					y2={96.3006}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={0.509653} stopColor="#B1D2DB" />
					<stop offset={1} stopColor="#F5FCFF" />
				</linearGradient>
				<clipPath id="bgblur_0_1110_644_clip_path" transform="translate(8.317 -18.015)">
					<path d="m110.39 55.646-19.15-19.03c-.806-.801-2.11-.801-2.915 0l-19.15 19.03c-1.298 1.289-.381 3.496 1.457 3.496h6.764c0 18.58 1.961 27.858-67.713 37.159h66.633c5.558 0 10.847-3.053 14.98-6.738 11.309-9.732 10.893-24.296 10.875-30.421h6.765c1.834 0 2.754-2.207 1.457-3.496z" />
				</clipPath>
				<filter
					id="filter0_i_1110_644"
					width={137.317}
					height={96.2861}
					x={-8.31689}
					y={18.0146}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect1_innerShadow_1110_644" />
				</filter>
			</defs>
		</svg>
	);
}
